import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IDateRangePicker } from '../../../interfaces/check-filter';
import { IDaterangeFilter } from '../../../interfaces/filter-config';
import { FilterHandlerService } from '../../../services/filter/filter-handler.service';
import { GoogleAnalyticsService } from '../../../services/google/google-analytics.service';
import { RangeDatepickerComponent } from '../../range-datepicker/range-datepicker.component';

@Component({
  selector: 'filter-date',
  templateUrl: './filter-date.component.html',
  styleUrls: ['./filter-date.component.scss'],
})
export class FilterDateComponent implements AfterViewInit {
  @ViewChild(RangeDatepickerComponent) private rangeDatepicker: RangeDatepickerComponent;

  @Input() public filter: IDaterangeFilter;

  @Output() public dateChanged: EventEmitter<any>;

  public daterangeOptions: IDateRangePicker;

  constructor(private filterHandlerService: FilterHandlerService, private googleAnalyticsService: GoogleAnalyticsService) {
    this.dateChanged = new EventEmitter<any>();
  }

  /**
   * App on view init
   */
  public ngAfterViewInit(): void {
    this.daterangeOptions = this.filter.options || {};

    this.filterHandlerService.clearFilter$.subscribe(() => {
      this.daterangeOptions = null;

      setTimeout(() => {
        this.daterangeOptions = this.filter.options || {};
        this.rangeDatepicker?.toggleCalendar(true);
        this.rangeDatepicker?.resetCalendar(this.daterangeOptions);
      }, 100);
    });
  }

  /**
   * Function triggered on date change
   *
   * @param $event Selected date
   */
  public changeSelectedDate($event: any): void {
    this.dateChanged.emit($event);
    const filter = {
      filter_selected: 'filter_date',
      value_selected: $event,
    };
    this.googleAnalyticsService.sendFilterEvent(filter);
  }
}
